import { STORAGE_KEYS } from '../constants';

export function getSavedToken(): string {
  try {
    return localStorage.getItem(STORAGE_KEYS.SIGS_BEARER_TOKEN) ?? '';
  } catch {
    return '';
  }
}

export function saveToken(token: string): void {
  try {
    localStorage.setItem(STORAGE_KEYS.SIGS_BEARER_TOKEN, token);
  } catch {
    // quota exceeded — ignore
  }
}

export function clearSavedToken(): void {
  try {
    localStorage.removeItem(STORAGE_KEYS.SIGS_BEARER_TOKEN);
  } catch {
    // ignore
  }
}
